/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiResponse1Boolean,
  ApiResponse1DashboardParametersResponse,
  ApiResponse1MeResponse,
  ApiResponse1NotificationListResponse,
  ApiResponse1Object,
  ApiResponse1String,
  ApiResponse1UserEmailListResponse,
  ApiResponse1UserListResponse,
  ApiResponse1UserResponse,
  MicrosoftAspNetCoreMvcProblemDetails,
  RevisdomAPIViewModelsUserChangeNotificationsStatusRequest,
  RevisdomAPIViewModelsUserCreateUserRequest,
  RevisdomAPIViewModelsUserSubscribeWebPushRequest,
} from '../models/index';
import {
    ApiResponse1BooleanFromJSON,
    ApiResponse1BooleanToJSON,
    ApiResponse1DashboardParametersResponseFromJSON,
    ApiResponse1DashboardParametersResponseToJSON,
    ApiResponse1MeResponseFromJSON,
    ApiResponse1MeResponseToJSON,
    ApiResponse1NotificationListResponseFromJSON,
    ApiResponse1NotificationListResponseToJSON,
    ApiResponse1ObjectFromJSON,
    ApiResponse1ObjectToJSON,
    ApiResponse1StringFromJSON,
    ApiResponse1StringToJSON,
    ApiResponse1UserEmailListResponseFromJSON,
    ApiResponse1UserEmailListResponseToJSON,
    ApiResponse1UserListResponseFromJSON,
    ApiResponse1UserListResponseToJSON,
    ApiResponse1UserResponseFromJSON,
    ApiResponse1UserResponseToJSON,
    MicrosoftAspNetCoreMvcProblemDetailsFromJSON,
    MicrosoftAspNetCoreMvcProblemDetailsToJSON,
    RevisdomAPIViewModelsUserChangeNotificationsStatusRequestFromJSON,
    RevisdomAPIViewModelsUserChangeNotificationsStatusRequestToJSON,
    RevisdomAPIViewModelsUserCreateUserRequestFromJSON,
    RevisdomAPIViewModelsUserCreateUserRequestToJSON,
    RevisdomAPIViewModelsUserSubscribeWebPushRequestFromJSON,
    RevisdomAPIViewModelsUserSubscribeWebPushRequestToJSON,
} from '../models/index';

export interface ApiUserDashboardGetRequest {
    startDate?: Date;
}

export interface ApiUserEditPostRequest {
    firstName?: string;
    lastName?: string;
    title?: string;
    oldPassword?: string;
    newPassword?: string;
    thumbnail?: Blob;
    notificationToEmail?: boolean;
}

export interface ApiUserEmailsGetRequest {
    searchTerm?: string;
}

export interface ApiUserIdDeleteRequest {
    id: number;
}

export interface ApiUserNotificationsChangeStatusPostRequest {
    revisdomAPIViewModelsUserChangeNotificationsStatusRequest?: RevisdomAPIViewModelsUserChangeNotificationsStatusRequest;
}

export interface ApiUserNotificationsGetRequest {
    unread?: boolean;
}

export interface ApiUserPostRequest {
    revisdomAPIViewModelsUserCreateUserRequest?: RevisdomAPIViewModelsUserCreateUserRequest;
}

export interface ApiUserSubscribeWebPushPostRequest {
    revisdomAPIViewModelsUserSubscribeWebPushRequest?: RevisdomAPIViewModelsUserSubscribeWebPushRequest;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * **Required Roles:** Admin, SuperAdmin  
     */
    async apiUserDashboardGetRaw(requestParameters: ApiUserDashboardGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1DashboardParametersResponse>> {
        const queryParameters: any = {};

        if (requestParameters['startDate'] != null) {
            queryParameters['startDate'] = (requestParameters['startDate'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/User/dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1DashboardParametersResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  
     */
    async apiUserDashboardGet(requestParameters: ApiUserDashboardGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1DashboardParametersResponse> {
        const response = await this.apiUserDashboardGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  
     */
    async apiUserEditPostRaw(requestParameters: ApiUserEditPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1UserResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['firstName'] != null) {
            formParams.append('FirstName', requestParameters['firstName'] as any);
        }

        if (requestParameters['lastName'] != null) {
            formParams.append('LastName', requestParameters['lastName'] as any);
        }

        if (requestParameters['title'] != null) {
            formParams.append('Title', requestParameters['title'] as any);
        }

        if (requestParameters['oldPassword'] != null) {
            formParams.append('OldPassword', requestParameters['oldPassword'] as any);
        }

        if (requestParameters['newPassword'] != null) {
            formParams.append('NewPassword', requestParameters['newPassword'] as any);
        }

        if (requestParameters['thumbnail'] != null) {
            formParams.append('Thumbnail', requestParameters['thumbnail'] as any);
        }

        if (requestParameters['notificationToEmail'] != null) {
            formParams.append('NotificationToEmail', requestParameters['notificationToEmail'] as any);
        }

        const response = await this.request({
            path: `/api/User/edit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1UserResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin  
     */
    async apiUserEditPost(requestParameters: ApiUserEditPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1UserResponse> {
        const response = await this.apiUserEditPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor, Commenter  
     */
    async apiUserEmailsGetRaw(requestParameters: ApiUserEmailsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1UserEmailListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['searchTerm'] != null) {
            queryParameters['searchTerm'] = requestParameters['searchTerm'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/User/emails`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1UserEmailListResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** Admin, SuperAdmin, Editor, Commenter  
     */
    async apiUserEmailsGet(requestParameters: ApiUserEmailsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1UserEmailListResponse> {
        const response = await this.apiUserEmailsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** SuperAdmin, Admin  
     * Tüm kullanıcıları listeler (silinmiş dahil; `isDeleted` ile ayırt edilir). Yalnızca SuperAdmin.
     */
    async apiUserGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1UserListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/User`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1UserListResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** SuperAdmin, Admin  
     * Tüm kullanıcıları listeler (silinmiş dahil; `isDeleted` ile ayırt edilir). Yalnızca SuperAdmin.
     */
    async apiUserGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1UserListResponse> {
        const response = await this.apiUserGetRaw(initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** SuperAdmin, Admin  
     * Kullanıcıya soft delete uygular. Yalnızca SuperAdmin. Kendi hesabını veya SuperAdmin rolündeki kullanıcıları silemezsiniz.
     */
    async apiUserIdDeleteRaw(requestParameters: ApiUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1Boolean>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiUserIdDelete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/User/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1BooleanFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** SuperAdmin, Admin  
     * Kullanıcıya soft delete uygular. Yalnızca SuperAdmin. Kendi hesabını veya SuperAdmin rolündeki kullanıcıları silemezsiniz.
     */
    async apiUserIdDelete(requestParameters: ApiUserIdDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1Boolean> {
        const response = await this.apiUserIdDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserMeGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1MeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/User/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1MeResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUserMeGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1MeResponse> {
        const response = await this.apiUserMeGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserNotificationsChangeStatusPostRaw(requestParameters: ApiUserNotificationsChangeStatusPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1Object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/User/notifications/change-status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsUserChangeNotificationsStatusRequestToJSON(requestParameters['revisdomAPIViewModelsUserChangeNotificationsStatusRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1ObjectFromJSON(jsonValue));
    }

    /**
     */
    async apiUserNotificationsChangeStatusPost(requestParameters: ApiUserNotificationsChangeStatusPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1Object> {
        const response = await this.apiUserNotificationsChangeStatusPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserNotificationsGetRaw(requestParameters: ApiUserNotificationsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1NotificationListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['unread'] != null) {
            queryParameters['unread'] = requestParameters['unread'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/User/notifications`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1NotificationListResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiUserNotificationsGet(requestParameters: ApiUserNotificationsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1NotificationListResponse> {
        const response = await this.apiUserNotificationsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * **Required Roles:** SuperAdmin, Admin  
     */
    async apiUserPostRaw(requestParameters: ApiUserPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1UserResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/User`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsUserCreateUserRequestToJSON(requestParameters['revisdomAPIViewModelsUserCreateUserRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1UserResponseFromJSON(jsonValue));
    }

    /**
     * **Required Roles:** SuperAdmin, Admin  
     */
    async apiUserPost(requestParameters: ApiUserPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1UserResponse> {
        const response = await this.apiUserPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiUserSubscribeWebPushPostRaw(requestParameters: ApiUserSubscribeWebPushPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ApiResponse1String>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/User/subscribe-web-push`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevisdomAPIViewModelsUserSubscribeWebPushRequestToJSON(requestParameters['revisdomAPIViewModelsUserSubscribeWebPushRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiResponse1StringFromJSON(jsonValue));
    }

    /**
     */
    async apiUserSubscribeWebPushPost(requestParameters: ApiUserSubscribeWebPushPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ApiResponse1String> {
        const response = await this.apiUserSubscribeWebPushPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
